module.exports = __webpack_public_path__ + "img/banner4.c6af08b3.png";